export const API_LOGIN = "/user/login";
export const API_GET_BANKS = "/api/getbanks";
export const API_GET_IMAGES = "/api/getimage";
export const API_GET_ICONS = "/api/geticon";
export const API_GET_Notification = "/api/getnotification";
export const API_GET_Authenticate = "/api/authenticate";
export const API_GET_ValidateToken = "/api/ValidateToken";
export const urlImagev2 = process.env.REACT_APP_API_URL_IMAGE_V2;
